import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconRefreshCcw = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-refresh-ccw" data-icon="icon-refresh-ccw" aria-hidden="true" {...props} ref={ref}><path d="M3 2v6h6"/><path d="M21 12A9 9 0 0 0 6 5.3L3 8"/><path d="M21 22v-6h-6"/><path d="M3 12a9 9 0 0 0 15 6.7l3-2.7"/></svg>);
});

IconRefreshCcw.displayName = 'IconRefreshCcw';
